module.exports = __webpack_public_path__ + "static/media/caminho-106.d8fdc45a.png";